import React, { useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context/index";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayEmpty, isArrayNotEmpty } from "utils/empty-exists";
import { HeroCarouselSlide } from "cms/components/components/hero-carousel/display/hero-carousel-slide";
import { useImageLoader } from "cms/components/components/hero-carousel/display/use-image-loader";
import { Logger } from "cms/utils/log/logger";

const HeroCarouselComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const slides = component?.slides ?? [];
    const contentPosition = component?.content_position ?? "left";
    const hasContent = isArrayNotEmpty(slides);
    const total = slides?.length ?? 0;
    
    const {
        fetchImageData,
        preloadImageArray
    } = useImageLoader();
    
    const [index, setIndex] = useState(0);
    // const [datas, setDatas] = useState([])
    const [images, setImages] = useState(null);
    
    const buildSlidesData = async (slides) => {
        const datas = [];
        try {
            for (const slide of slides) {
                const { image } = slide || {};
                const { image: image_guid } = image || {};
                if (image_guid) {
                    const data = await fetchImageData(image_guid);
                    datas.push(data);
                }
            }
            const images = await preloadImageArray(datas);
            // setDatas(datas)
            setImages(images);
        } catch (err) {
            Logger.error(err);
        }
        return images;
    };
    
    useEffect (() => {
        buildSlidesData(slides);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides]);
    
    function moveIndex (increment) {
        let idx = index + increment;
        if (idx > slides.length - 1) {
            idx = 0;
        }
        if (idx < 0) {
            idx = slides.length - 1;
        }
        setIndex(idx);
    }
    
    if (isArrayEmpty (slides)) {
        return (
            <EmptyContentMessage
                hasContent={hasContent}
                component={component}
            />
        );
    } else {
        return (
            <div className="carousel-container">
                <HeroCarouselSlide
                    slides={slides}
                    images={images}
                    key={index}
                    index={index}
                    total={total}
                    moveIndex={moveIndex}
                    contentPosition={contentPosition}
                />
            </div>
        );
    }
};

HeroCarouselComponentDisplay.displayName = "HeroCarouselComponentDisplay";
export { HeroCarouselComponentDisplay };
